module.exports = __webpack_public_path__ + "static/media/blue-gradient-circle-500.618cd134.png";